/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Card , Row , Col} from 'react-bootstrap'
import {SectionMenu} from '../components';
import StudentImport from '../components/students/student-import.js';
import ClassImport from '../components/students/class-import.js';
import UpdateCurriculumSettings from '../components/settings.js'
import ProductService from '../services/product-service.js'
import ProductStore from '../store/product-store.js'
import Constants from '../constants.js';
import Translation from '../store/internationalization-store.js';
import {Advanced, Subscription} from '../components/establishment';
import {NotificationsAndMarketing} from '../components/notifications-and-marketing';
import {PersonalInformation , PasswordChange} from '../components/personal';
import Package from '../classes/package.js';

export default class Settings extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab:this.props.match.params.tab,
            accountItems:[
                {id:"curriculums"  , name:Translation.get(12753, 'Vocabulary + Settings') , disabled:false},
                {id:"subscription"  , name:Translation.get(796, 'Contact Us') , disabled:false},
                {id:"personal"  , name:Translation.get(12754, 'Teacher Details') , disabled:false}
            ],
            primaryAccountItems:[
                {id:"curriculums"  , name:Translation.get(906, 'Settings') , disabled:false},
                {id:"subscription"  , name:Translation.get(796, 'Contact Us') , disabled:false},
                {id:"personal"  , name:Translation.get(12754, 'Teacher Details') , disabled:false}
            ],
            personalItems:[
                {id:"curriculums"  , name:Translation.get(12753, 'Vocabulary + Settings') , disabled:false},
                {id:"personal" , name:Translation.get(12755, 'Personal Information') , disabled:false},
            ],
            primaryItems:[
                {id:"curriculums"  , name:Translation.get(906, 'Settings') , disabled:false},
                {id:"personal" , name:Translation.get(12755, 'Personal Information') , disabled:false},
            ],
            type:"teacher"
        };
    }

    componentWillMount(){
        ProductStore.on(Constants.GET_USER_DATA,  ()=>{
            var userData = ProductStore.getUserData();
            var isSecondary = (new Package()).isSecondary(userData.package);
            if (userData.userType == "admin" || userData.userType == "school") {
                this.setState({type:"admin", isSecondary:isSecondary});
            } else {
                this.setState({type:"teacher", isSecondary:isSecondary});
            }
        });
    }

    componentDidMount() {
        ProductService.getAllAdditionalCurriculums();
        ProductService.getUserData();
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.setState({
            tab:this.props.match.params.tab,
        })
    }

    getBody(){

        switch(this.state.tab)
        {
            case "establishment" : return <UpdateCurriculumSettings/>
            case "curriculums" : return <UpdateCurriculumSettings/>
            case "personal" : return <PersonalInformation/>
            case "password" : return <PasswordChange/>
            case "notifications_marketing" : return <NotificationsAndMarketing/>
            case "importer_student" : return <StudentImport/>
            case "importer_classes" : return <ClassImport/>
            case "subscription" : return <Subscription/>
            case "advanced": return <Advanced/>
            default: return null;
        }

    }

    handleSelect(eventKey) {
        window.location.hash = "settings/"+eventKey;
    }

    render(){
        var data = this.state.accountItems;
        if (this.state.type == "teacher") {
            if (this.state.isSecondary) {
                data = this.state.personalItems;
            } else {
                data = this.state.primaryItems;
            }
        } else if (!this.state.isSecondary) {
            data = this.state.primaryAccountItems;
        }
        return <div>
                    <Row>
                        <Col>
                            <Card body >
                                {this.getBody()}
                            </Card>
                        </Col>
                    </Row>
                </div>


    }

}